<template>
  <div class="viewcontent" v-if="translations.budget">
    <form class="row mx-3" @submit.prevent="processBudget()">
      <Alert type="warning" :list="errors.budget"/>
      <div class="col-sm-6 col-xs-12">
        <!-- <label class="form-check-label w-100 my-2 form-check " for="ods">
          Objectius de Desenvolupament Sostenible
          <div
            class="form-check-label item"
            v-for="(item, index) in ods"
            :key="index"
            name="ods"
          >
            <label>
              <input
                class="form-check-input"
                type="checkbox"
                :value="item.id"
                v-model="budget.ods"
                :disabled="activity_finished"
              />
              {{ item.title }}</label
            >
          </div>
        </label> -->
        <label for="programs" class="form-check-label w-100 my-2 form-check ">
          {{ translations.budget.form_programs }}
          <div v-if="programs.length > 0">
            <div
              class="form-check-label item"
              v-for="(item, index) in programs"
              :key="index"
              name="programs"
            >
              <label>
                <input
                  class="form-check-input"
                  type="checkbox"
                  :value="item.id"
                  v-model="budget.programs"
                />
                {{ defineTitle(item.title) }}</label
              >
            </div>
          </div>
          <Alert type="warning" :message="defineError" v-else/>
        </label>
        <label for="objectives" class="form-label w-100 my-3">
          {{ translations.budget.form_objectives }}

          <textarea
            rows="5"
            class="form-control"
            id="objectives"
            name="objectives"
            v-model="budget.objectives"
            :disabled="activity_finished"
          >
          </textarea>
        </label>
        <label for="expected_results " class="form-label w-100 my-3">
          {{ translations.budget.form_expected_results }}

          <textarea
            rows="5"
            class="form-control"
            id="expected_results "
            name="expected_results "
            v-model="budget.expected_results"
            :disabled="activity_finished"
          >
          </textarea>
        </label>
        <label for="status" class="form-label w-100 my-3">
          {{ translations.budget.form_addressee }}
          <select
            class="form-select"
            id="status"
            name="status"
            v-model="budget.addressee"
            :disabled="activity_finished"
          >
            <option
              v-for="(item, index) in agetypes"
              :key="index"
              :value="item.id"
            >
              {{ item.title }}
            </option>
          </select>
        </label>
        <label for="budget_initial " class="form-label w-100 my-3">
          {{ translations.budget.form_budget_initial }}

          <input
            type="number"
            min="0"
            id="budget_initial "
            name="budget_initial "
            class="form-control"
            v-model="budget.budget_initial"
            :disabled="activity_finished"
          />
        </label>
        <label for="budget_initial_text  " class="form-label w-100 my-3">
          {{ translations.budget.budget_initial_text }}

          <textarea
            rows="5"
            class="form-control"
            id="budget_initial_text  "
            name="budget_initial_text  "
            v-model="budget.budget_initial_text"
            :disabled="activity_finished"
          >
          </textarea>
        </label>
      </div>
      <div class="col-sm-6 col-xs-12">
        <label for="attendees_num " class="form-label w-100 my-3">
          {{ translations.budget.budget_attendees_num }}

          <input
            type="number"
            min="0"
            id="attendees_num "
            name="attendees_num "
            class="form-control"
            v-model="budget.attendees_num"
          />
        </label>
        <label for="attendees_text  " class="form-label w-100 my-3">
          {{ translations.budget.budget_attendees_text }}

          <textarea
            rows="5"
            class="form-control"
            id="attendees_text  "
            name="attendees_text  "
            v-model="budget.attendees_text"
          >
          </textarea>
        </label>
        <label for="participant_num " class="form-label w-100 my-3">
          {{ translations.budget.budget_participant_num }}

          <input
            type="number"
            min="0"
            id="participant_num "
            name="participant_num "
            class="form-control"
            v-model="budget.participant_num"
          />
        </label>
        <label for="participant_text  " class="form-label w-100 my-3">
          {{ translations.budget.budget_participant_text }}

          <textarea
            rows="5"
            class="form-control"
            id="participant_text  "
            name="participant_text  "
            v-model="budget.participant_text"
          >
          </textarea>
        </label>

        <label for="budget_final " class="form-label w-100 my-3">
          {{ translations.budget.budget_budget_final }}
          <input
            type="number"
            min="0"
            id="budget_final "
            name="budget_final "
            class="form-control"
            v-model="budget.budget_final"
          />
        </label>
        <label for="budget_final_text  " class="form-label w-100 my-3">
          {{ translations.budget.budget_budget_final_text }}

          <textarea
            rows="5"
            class="form-control"
            id="budget_final_text  "
            name="budget_final_text  "
            v-model="budget.budget_final_text"
          >
          </textarea>
        </label>

        <label for="attendees_evaluation  " class="form-label w-100 my-3">
          {{ translations.budget.budget_attendees_evaluation }}

          <textarea
            rows="5"
            class="form-control"
            id="attendees_evaluation  "
            name="attendees_evaluation  "
            v-model="budget.attendees_evaluation"
          >
          </textarea>
        </label>

        <label for="participant_evaluation  " class="form-label w-100 my-3">
          {{ translations.budget.budget_participant_evaluation }}

          <textarea
            rows="5"
            class="form-control"
            id="participant_evaluation  "
            name="participant_evaluation  "
            v-model="budget.participant_evaluation"
          >
          </textarea>
        </label>
      </div>
      <div class="col-12 pt-2">
        <label for="global_evaluation " class="form-label w-100 my-3">
          {{ translations.budget.budget_global_evaluation }}

          <input
            type="number"
            min="0"
            max="5"
            id="global_evaluation "
            name="global_evaluation "
            class="form-control"
            v-model="budget.global_evaluation"
          />
        </label>
      </div>
      <div class="col-12 pt-2" v-if="translations.buttons">
        <button class="btn btn-danger mx-2" type="button" @click="cancel()">
          {{ translations.buttons.btn_exit }}
        </button>
        <input
          class="btn btn-primary mx-2"
          type="submit"
          :value="translations.buttons.btn_save"
        />
      </div>
    </form>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import Alert from '@/components/atoms/Alert.vue'
  export default {
    name: 'ToolActivityBudget',
    components: {
      Alert,
    },
    data() {
      return {
        agetypes: [],
      }
    },
    computed: {
      ...mapState([
        'translations',
        'ods',
        'budget',
        'errors',
        'activity_finished',
        'programs',
        'languageSelected',
        'editor_activity',
      ]),
      defineError() {
        if (this.translations.errors) {
          let result = this.translations.errors.budget_programs
          if (this.editor_activity == 'editor') {
            result = this.translations.errors.budget_programs_editor
          }
          return result
        }
      },
    },
    watch: {
      translations(newT, oldT) {
        this.addTranslations()
      },
    },
    methods: {
      ...mapActions([
        'getBudget',
        'changeToolSelected',
        'editBudget',
        'getPrograms',
      ]),

      cancel() {
        this.changeToolSelected(11)
      },
      processBudget() {
        this.editBudget(this.budget)
      },
      defineTitle(title) {
        let text = ''

        if (title) {
          let result = title.find((x) => x.key === this.languageSelected)
          text = result && result.text ? result.text : title[0].text
        }

        return text
      },
      addTranslations() {
        if (this.translations.agetypes) {
          this.agetypes = [
            { id: 'infantile', title: this.translations.agetypes.infantile },
            {
              id: 'adolescence',
              title: this.translations.agetypes.adolescence,
            },
            { id: 'youth', title: this.translations.agetypes.youth },
            { id: 'adult', title: this.translations.agetypes.adult },
            { id: 'old', title: this.translations.agetypes.old },
          ]
        }
      },
    },
    async created() {
      await this.getBudget()
      await this.getPrograms(this.editor_activity)
      this.addTranslations()
    },
  }
</script>

<style scoped>
  .form-check {
    padding-left: initial;
  }
  .form-check .item {
    text-align: left;
    padding-left: 1.5rem;
  }
</style>
